<button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss()">
</button>

<div class="modal-body text-center">
    <h2 class="modal-title h2 lh-sm fw-bold mb-3">
        {{ popupTitle }}
    </h2>
    <p class="mb-0 h5">
        {{ popupSubTitle }}
    </p>
</div>
<div class="modal-footer justify-content-center border-0">
    <a 
        [href]="popupButtonLink"
        type="button"
        target="_blank"
        class="btn btn-lg btn-success text-white shadow fs-3 w-100"
        (click)="activeModal.close()">
            {{ popupButtonText }}
    </a>
</div>
